<div class="card shadow-sm mt-2">
  <div class="card-header">
    <h3 class="card-title">Change of Scope</h3>
  </div>
  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }
    <form [formGroup]="form">
      <div class="row g-3">
        <div class="col-12 mt-2">
          <textarea-field label="Reason of change of scope" placeholder="Write the reason of change of scope here..."
            [textareaFormControl]="getChangeOfScopeReasonInput()" [height]="150" [readonly]="readonlyReasonChangeOfScope" />
        </div>
      </div>
    </form>
  </div>
</div>
